// start:ng42.barrel
export * from './redirector.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/redirector/index.ts